module.exports = Object.freeze({
  STATUS_OFFER_MADE: 'offerMade',
  STATUS_OFFER_ACCEPTED: 'offerAccepted',
  STATUS_OFFER_DECLINED: 'offerDeclined',
  STATUS_COMPLETE: 'complete',
  statuses: [
    'STATUS_OFFER_MADE',
    'STATUS_OFFER_ACCEPTED',
    'STATUS_OFFER_DECLINED',
    'STATUS_COMPLETE',
  ],
  blankMedicalQuestionnaire: {
    tuberculosisAsthma: '',
    heartCondition: '',
    blackoutsGiddiness: '',
    depressionBreakdown: '',
    rheumatismArthritis: '',
    backTrouble: '',
    typhoidParatyphoid: '',
    digestiveBowel: '',
    diabetesGland: '',
    bladderKidney: '',
    dermatitisSkin: '',
    varicoseVeins: '',
    visionHearing: '',
    accidentIllness: '',
    communicableDisease: '',
    preventAttending: '',
    affectAttendance: '',
    effectAbility: '',
    youSmoke: '',
    // notes for each
    tuberculosisAsthmaNotes: '',
    heartConditionNotes: '',
    blackoutsGiddinessNotes: '',
    depressionBreakdownNotes: '',
    rheumatismArthritisNotes: '',
    backTroubleNotes: '',
    typhoidParatyphoidNotes: '',
    digestiveBowelNotes: '',
    diabetesGlandNotes: '',
    bladderKidneyNotes: '',
    dermatitisSkinNotes: '',
    varicoseVeinsNotes: '',
    visionHearingNotes: '',
    accidentIllnessNotes: '',
    communicableDiseaseNotes: '',
    preventAttendingNotes: '',
    affectAttendanceNotes: '',
    effectAbilityNotes: '',
    youSmokeNotes: '',
    // and finally
    prescribedMedications: '',
    furtherDetails: '',
  },
  blankMedicalQuestionnaireNights: {
    nightPreventedNight: '',
    nightYouDiabetic: '',
    nightAnginaHeart: '',
    nightCirculatoryProblems: '',
    nightDuodenalUlcers: '',
    nightChronicAsthma: '',
    nightDisabilityMobility: '',
    nightSleepDisturbance: '',
    nightSpecialistCare: '',
    nightFitnessNight: '',
    nightMedicationTimetable: '',
    nightBowelProblem: '',
    // notes for each
    nightPreventedNightNotes: '',
    nightYouDiabeticNotes: '',
    nightAnginaHeartNotes: '',
    nightCirculatoryProblemsNotes: '',
    nightDuodenalUlcersNotes: '',
    nightChronicAsthmaNotes: '',
    nightDisabilityMobilityNotes: '',
    nightSleepDisturbanceNotes: '',
    nightSpecialistCareNotes: '',
    nightFitnessNightNotes: '',
    nightMedicationTimetableNotes: '',
    nightBowelProblemNotes: '',
  },
});
